// =============================================================================
// Global singletons needed on each page.
// -----------------------------------------------------------------------------
//

/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";

import KeyName from "legacy/keynames";
import OkC from "shared/util/OkcApi";
import Context from "shared/util/Context";
import getImagePath from "shared/util/getImagePath";

// Cross-browser requestAnimationFrame
if (!window.requestAnimationFrame) {
	window.requestAnimationFrame = (function() {
		return window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function(/* function FrameRequestCallback */ callback) {
			window.setTimeout( callback, 1000 / 60 );
		};
	})();
}


window.jQuery.fn.scrollParent = function() {
	let overflowRegex = /(auto|scroll)/;
	let position = this.css("position");
	let excludeStaticParent = position === "absolute";
	let scrollParent = this.parents()
		.filter(function() {
			let parent = jQuery(this);
			if (excludeStaticParent && parent.css("position") === "static") {
				return false;
			}
			return overflowRegex.test(
				parent.css("overflow") +
					parent.css("overflow-y") +
					parent.css("overflow-x")
			);
		})
		.eq(0);
	if (position === "fixed" || !scrollParent.length) {
		return jQuery(this[0].ownerDocument || document);
	} else {
		return scrollParent;
	}
};

// Fix window.location.origin for IE
if (!window.location.origin) {
	window.location.origin =
		window.location.protocol +
		"//" +
		window.location.hostname +
		(window.location.port ? `:${window.location.port}` : "");
}

// Alter core number prototype functions
window.Number.prototype.mod = function(n) {
	return (this % n + n) % n;
};


// ==========================================================================
// Helpers to run on document ready
// -------------------------------------------------------------------------

$(document).ready(function() {
	// Apply tab-focus class when tabbing.
	let elems = 'a, button, select, input[type="submit"]';
	$("body").on("keyup", elems, e => {
		return $(e.target).addClass("tab_focus");
	});
	$("body").on("blur", elems, e => {
		return $(e.target).removeClass("tab_focus");
	});

	// replace broken user images
	return ImageHelpers.watchBrokenImages();
});


// ==========================================================================
// Set of helpers that deal with images
// -------------------------------------------------------------------------

window.ImageHelpers = {
	fixableImages: {
		".user_image": "ir4gMY/jFOIiGESqDhDQtbTgjww=",
		".nav-user-image-thumb": "ljX4pOZJuvZmUPKRzy+TXzAx/84=",
		"#matchphotobrowser": "k9knR9ORU/Sge8ADIiRW9kOF8wU=",
		".visited-list-item": "90FaS9Ob9qwwfwEIpIBp6NG0F7E=",
		".card": "a7Z5/OqJMBjJs67mXRmkUrM7xMk=",
		"#profile_thumbs": "9Y5XNrX5qitnRtoZl9l9MV6bEXI=",
		".match_card": "eUBKftlUMuDfM1KE/75BmeiOLZY=",
	},

	placeholderSizes: [60, 82, 100, 120, 160, 220, 225, 383, 400, 480, 640],
	placeholderPrefix: "media/img/user/placeholder_2013/pq_",

	watchBrokenImages() {
		this.brokenImageCount = 0;

		return $("img").on("error", e => {
			return this.fixBrokenImage(e.currentTarget);
		});

		// when the page is done loading (including the replaced images), post
		// a stat with the count
		/*$(window).load(=>
	if @brokenImageCount > 0
		window.util.updateStats("desktop - broken image count per page load", @brokenImageCount, "value", "3JcvBgHUa5DEjw2GBDr4G6Nba/U=")
  )*/
	},

	//util.updateStats("desktop - broken image - #{el}", 1, "counter", @fixableImages[el])
	fixBrokenImage(image) {
		image = $(image);
		let isWhitelisted = false;

		// don't attempt to replace broken placeholder images
		if (image.attr("src").match(this.placeholderPrefix)) {
			return;
		}

		// only continue if this image is contained by a whitelisted wrapper
		for (let el of Object.keys(this.fixableImages)) {
			if (image.closest(el).length) {
				isWhitelisted = true;
				break;
			}
		}

		if (!isWhitelisted) {
			return;
		}

		this.brokenImageCount++;

		let size = Math.max(image.width(), image.height());

		for (let placeholderSize of this.placeholderSizes) {
			if (placeholderSize > size) {
				size = placeholderSize;
				break;
			}
		}

		let placeholder = `${getImagePath()}${this.placeholderPrefix}${size}.png`;
		image.attr("src", placeholder);

		return ClientStats.update("desktop - fixed broken image");
	},
};

// ==========================================================================
// Set of string helper functions.
// --------------------------------------------------------------------------

window.StringHelpers = {
	sentenceCase(...strings) {
		//filter out empty strings
		let filteredStrings = strings
			.filter(string => string.length > 0)
			.map(string => string);
		return `${filteredStrings[0].substr(0, 1).toUpperCase() +
			filteredStrings[0].substr(1)} ${filteredStrings.slice(1).join(" ")}`;
	},

	htmlEscape(str) {
		return String(str)
			.replace(/&/g, "&amp;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;");
	},

	// Naive implementation, just adds 's' to word if value isn't 1
	pluralize(str, val) {
		if (val === 1) {
			return str;
		} else {
			return str + "s";
		}
	},

	linkUrls(text) {
		// strip script tags (since this could be run on things that used to be
		// text, but are now going to be html)
		text = text.replace(/<.*?script.*?>/g, "");

		// urls starting with www
		text = text.replace(
			/(^|[^'"\/])\b((?:www)\.[^\s^<]+)\b(-)?/g,
			"$1<a href='http://$2$3' target='_blank'>$2$3</a>"
		);

		// urls starting with http or https
		text = text.replace(
			/(^|[^'"\/])\b(https?:\/\/[^\s^<]+)\b(-)?/g,
			"$1<a href='$2$3' target='_blank'>$2$3</a>"
		);

		return text;
	},
};

// ==========================================================================
// Set of helper functions that handle tabbing functionality.
// -------------------------------------------------------------------------

window.tabindex = {
	// Set a custom tabindex on elements.
	// remove tabindex on all items, iterate through passed array of jQuery
	// elements or selectors, incrementing their tabindexes
	set(arr) {
		for (var el of $("[tabindex]")) {
			$(el).removeAttr("tabindex");
			if (__guard__($(el).data(), x => x.chosen) != null) {
				$(el).data().chosen.set_tab_index();
			}
		}

		return (() => {
			let result = [];
			for (let i = 0; i < arr.length; i++) {
				// If they passed a selector, get it.
				el = arr[i];
				if (typeof el === "string") {
					el = $(el);
				}

				el.attr("tabindex", i + 1);
				if (__guard__(el.data(), x1 => x1.chosen) != null) {
					result.push(el.data().chosen.set_tab_index());
				} else {
					result.push(undefined);
				}
			}
			return result;
		})();
	},

	contain(element) {
		let tabbableTags = "input, textarea, select, button, a";
		return element.on("keydown", tabbableTags, ev => {
			if (ev.keyCode !== KeyName.TAB) {
				return;
			}

			let tabbables = $(element).find(tabbableTags);
			let first = tabbables.filter(":first");
			let last = tabbables.filter(":last");

			if (ev.target === last[0] && !ev.shiftKey) {
				first.focus(1);
				return false;
			} else if (ev.target === first[0] && ev.shiftKey) {
				last.focus(1);
				return false;
			}
		});
	},
};

// ==========================================================================
// Manage tooltips seen by user. BE SURE TO ADD FEATURE TO USER_GUIDES.PUB
// --------------------------------------------------------------------------

window.userGuides = {
	understands(feature, cb) {
		return this.query("understands", feature, cb);
	},

	graduate(feature, cb) {
		return this.query("graduate", feature, cb);
	},

	ungraduate(feature, cb) {
		return this.query("ungraduate", feature, cb);
	},

	reset(feature, cb) {
		return this.query("reset", feature, cb);
	},

	query(type, feature, cb) {
		let params = {};
		params[type] = feature;
		params.random = Math.ceil(Math.random() * 100000);

		return OkC.legacy(
			"/util/user_guides",
			{
				type: "GET",
				data: params,

				success: res => {
					if (cb) {
						return cb(res);
					}
				},

				error: () => {
					window.util.updateStats(
						"user guide ajax error",
						1,
						"counter",
						"P5k2YBjHmyYqtkif7dbVd3MNmiE="
					);

					if (cb) {
						return cb();
					}
				},
			},
		);
	},
};

// ==========================================================================
// Manage popups seen by user
// --------------------------------------------------------------------------

window.SeenAds = {
	uid: 0,
	localstorage: false,
	nanocookie: false,
	bundlename: "seenads",
	initted: false,

	// init
	// ----------------------------------------------------------------------

	init() {
		if (this.initted) {
			return;
		}
		this.initted = true;
		this.uid = Context.get("userid");
	},

	// Dev Interface!
	// ----------------------------------------------------------------------

	saw(adid) {
		let bundle = this._retrieve();
		return bundle[this.uid + adid] === "1";
	},

	add(adid) {
		let bundle = this._retrieve();
		bundle[this.uid + adid] = "1";
		return this._save(bundle);
	},

	remove(adid) {
		let bundle = this._retrieve();
		bundle[this.uid + adid] = "0";
		return this._save(bundle);
	},

	reset() {
		return this._save({});
	},

	// Private shit!
	// ----------------------------------------------------------------------

	_retrieve() {
		// init if not already initted
		this.init();

		let bundle = "";

		bundle = Storage.getItem(this.bundlename);

		if (!bundle) {
			bundle = "{}";
		}

		try {
			bundle = JSON.parse(bundle);
		} catch (e) {
			bundle = {};
			this.reset();
			window.util.updateStats(
				"adseen - status - failed to eval bundle",
				1,
				"counter",
				"nxV1owUfHRB1mRXWF4WDg6gy7x8="
			);
		}

		return bundle;
	},

	_save(bundle) {
		try {
			bundle = JSON.stringify(bundle);
		} catch (e) {
			window.util.updateStats(
				"adseen - status - failed to save bundle",
				1,
				"counter",
				"/JzXHOPOAejscmK4zR8av7xj6gY="
			);
			return;
		}

		return Storage.setItem(this.bundlename, bundle);
	},
};

// ==========================================================================
// Provides functions that help with scrolling
// -----------------------------------------------------------------------------

window.ScrollHelpers = {
	// Check if an element has a scrollbar.
	checkScroll(element, dir) {
		if (dir === "horizontal") {
			// Half pixels on innerWidth get rounded down.
			return element.prop("scrollWidth") > element.innerWidth() + 1;
		} else {
			return element.prop("scrollHeight") > element.innerHeight();
		}
	},

	// Prevent body from scrolling when you reach the top / bottom of an element
	preventOverscroll(element, forcePrevention) {
		if (typeof element === "string") {
			element = $(`#${element}`);
		}

		return element.on("mousewheel", (e, delta) => {
			// only preventOverscroll if the scrolling element is the same as the
			// bound element, and that the scrolling element's scrollParent is the
			// same as the bound element. this keeps preventOverscroll from happening
			// on nested scroll elements
			if (
				$(e.currentTarget)[0] !== $(e.target)[0] &&
				$(e.currentTarget)[0] !== $(e.target).scrollParent()[0]
			) {
				return;
			}

			// Only prevent if it's scrollable, or if we're forcing prevention.
			if (forcePrevention || ScrollHelpers.checkScroll(element)) {
				let scrollTop = element.scrollTop();
				let isAtBottom =
					scrollTop === element.prop("scrollHeight") - element.innerHeight();

				// Prevent top scroll
				if (delta > 0 && scrollTop === 0) {
					return e.preventDefault();
					// Prevent bottom scroll
				} else if (delta < 0 && isAtBottom) {
					return e.preventDefault();
				}
			}
		});
	},

	// Simple animated scroll.
	// Position - position of where to scroll in px from top.
	// Speed - speed to scroll in ms. Blank or 0 for instant jump.
	// Selector - Defaults to body, scroll to a position
	scrollTo(position, speed, selector) {
		selector = selector || "body, html, window, document";
		if (speed) {
			let scrollToInstance = $(selector).animate({
				scrollTop: position,
			}, speed);

			addEventListener("mousewheel", () => scrollToInstance.stop());

			return setTimeout(
				removeEventListener("mousewheel", function() {
					scrollToInstance.stop();
					return (scrollToInstance = null);
				})
			);
		} else {
			return $(selector).scrollTop(position);
		}
	},
};

//
// * jQuery Mousewheel 3.1.12
// *
// * Copyright 2014 jQuery Foundation and other contributors
// * Released under the MIT license.
// * http://jquery.org/license
//
(function(factory) {
	if (typeof define === "function" && define.amd) {
		// AMD. Register as an anonymous module.
		define(["jquery"], factory);
	} else if (typeof exports === "object") {
		// Node/CommonJS style for Browserify
		module.exports = factory;
	} else {
		// Browser globals
		factory(jQuery);
	}
})(function($) {
	// Store the line height and page height for this particular element

	// Clean up the data we added to the element
	// see shouldAdjustOldDeltas() below
	// calls getBoundingClientRect for each event
	let i;
	let handler = function(event) {
		let lowestDelta;
		let orgEvent = event || window.event;
		let args = slice.call(arguments, 1);
		let delta = 0;
		let deltaX = 0;
		let deltaY = 0;
		let absDelta = 0;
		let offsetX = 0;
		let offsetY = 0;
		event = $.event.fix(orgEvent);
		event.type = "mousewheel";

		// Old school scrollwheel delta
		if ("detail" in orgEvent) {
			deltaY = orgEvent.detail * -1;
		}
		if ("wheelDelta" in orgEvent) {
			deltaY = orgEvent.wheelDelta;
		}
		if ("wheelDeltaY" in orgEvent) {
			deltaY = orgEvent.wheelDeltaY;
		}
		if ("wheelDeltaX" in orgEvent) {
			deltaX = orgEvent.wheelDeltaX * -1;
		}

		// Firefox < 17 horizontal scrolling related to DOMMouseScroll event
		if ("axis" in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
			deltaX = deltaY * -1;
			deltaY = 0;
		}

		// Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
		delta = deltaY === 0 ? deltaX : deltaY;

		// New school wheel delta (wheel event)
		if ("deltaY" in orgEvent) {
			deltaY = orgEvent.deltaY * -1;
			delta = deltaY;
		}
		if ("deltaX" in orgEvent) {
			({ deltaX } = orgEvent);
			if (deltaY === 0) {
				delta = deltaX * -1;
			}
		}

		// No change actually happened, no reason to go any further
		if (deltaY === 0 && deltaX === 0) {
			return;
		}

		// Need to convert lines and pages to pixels if we aren't already in pixels
		// There are three delta modes:
		//   * deltaMode 0 is by pixels, nothing to do
		//   * deltaMode 1 is by lines
		//   * deltaMode 2 is by pages
		if (orgEvent.deltaMode === 1) {
			let lineHeight = $.data(this, "mousewheel-line-height");
			delta *= lineHeight;
			deltaY *= lineHeight;
			deltaX *= lineHeight;
		} else if (orgEvent.deltaMode === 2) {
			let pageHeight = $.data(this, "mousewheel-page-height");
			delta *= pageHeight;
			deltaY *= pageHeight;
			deltaX *= pageHeight;
		}

		// Store lowest absolute delta to normalize the delta values
		absDelta = Math.max(Math.abs(deltaY), Math.abs(deltaX));
		if (!lowestDelta || absDelta < lowestDelta) {
			lowestDelta = absDelta;

			// Adjust older deltas if necessary
			if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
				lowestDelta /= 40;
			}
		}

		// Adjust older deltas if necessary
		if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
			// Divide all the things by 40!
			delta /= 40;
			deltaX /= 40;
			deltaY /= 40;
		}

		// Get a whole, normalized value for the deltas
		delta = Math[delta >= 1 ? "floor" : "ceil"](delta / lowestDelta);
		deltaX = Math[deltaX >= 1 ? "floor" : "ceil"](deltaX / lowestDelta);
		deltaY = Math[deltaY >= 1 ? "floor" : "ceil"](deltaY / lowestDelta);

		// Normalise offsetX and offsetY properties
		if (special.settings.normalizeOffset && this.getBoundingClientRect) {
			let boundingRect = this.getBoundingClientRect();
			offsetX = event.clientX - boundingRect.left;
			offsetY = event.clientY - boundingRect.top;
		}

		// Add information to the event object
		event.deltaX = deltaX;
		event.deltaY = deltaY;
		event.deltaFactor = lowestDelta;
		event.offsetX = offsetX;
		event.offsetY = offsetY;

		// Go ahead and set deltaMode to 0 since we converted to pixels
		// Although this is a little odd since we overwrite the deltaX/Y
		// properties with normalized deltas.
		event.deltaMode = 0;

		// Add event and delta to the front of the arguments
		args.unshift(event, delta, deltaX, deltaY);

		// Clearout lowestDelta after sometime to better
		// handle multiple device types that give different
		// a different lowestDelta
		// Ex: trackpad = 3 and mouse wheel = 120
		if (nullLowestDeltaTimeout) {
			clearTimeout(nullLowestDeltaTimeout);
		}
		var nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
		return ($.event.dispatch || $.event.handle).apply(this, args);
	};
	var nullLowestDelta = function() {
		let lowestDelta = null;
	};
	var shouldAdjustOldDeltas = (orgEvent, absDelta) =>
		// If this is an older event and the delta is divisable by 120,
		// then we are assuming that the browser is treating this as an
		// older mouse wheel event and that we should divide the deltas
		// by 40 to try and get a more usable deltaFactor.
		// Side note, this actually impacts the reported scroll distance
		// in older browsers and can cause scrolling to be slower than native.
		// Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
		special.settings.adjustOldDeltas &&
		orgEvent.type === "mousewheel" &&
		absDelta % 120 === 0;
	let toFix = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"];
	let toBind =
		"onwheel" in document || document.documentMode >= 9
			? ["wheel"]
			: ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"];
	var { slice } = Array.prototype;
	let nullLowestDeltaTimeout = undefined;
	let lowestDelta = undefined;
	if ($.event.fixHooks) {
		i = toFix.length;

		while (i) {
			$.event.fixHooks[toFix[--i]] = $.event.mouseHooks;
		}
	}
	var special = ($.event.special.mousewheel = {
		version: "3.1.12",

		setup() {
			if (this.addEventListener) {
				i = toBind.length;

				while (i) {
					this.addEventListener(toBind[--i], handler, false);
				}
			} else {
				this.onmousewheel = handler;
			}
			$.data(this, "mousewheel-line-height", special.getLineHeight(this));
			$.data(this, "mousewheel-page-height", special.getPageHeight(this));
		},

		teardown() {
			if (this.removeEventListener) {
				i = toBind.length;

				while (i) {
					this.removeEventListener(toBind[--i], handler, false);
				}
			} else {
				this.onmousewheel = null;
			}
			$.removeData(this, "mousewheel-line-height");
			$.removeData(this, "mousewheel-page-height");
		},

		getLineHeight(elem) {
			let $elem = $(elem);
			let $parent = $elem["offsetParent" in $.fn ? "offsetParent" : "parent"]();
			if (!$parent.length) {
				$parent = $("body");
			}
			return (
				parseInt($parent.css("fontSize"), 10) ||
				parseInt($elem.css("fontSize"), 10) ||
				16
			);
		},

		getPageHeight(elem) {
			return $(elem).height();
		},

		settings: {
			adjustOldDeltas: true,
			normalizeOffset: true,
		},
	});

	$.fn.extend({
		mousewheel(fn) {
			if (fn) {
				return this.bind("mousewheel", fn);
			} else {
				return this.trigger("mousewheel");
			}
		},

		unmousewheel(fn) {
			return this.unbind("mousewheel", fn);
		},
	});
});

// ==========================================================================
// jQuery extenstions
// --------------------------------------------------------------------------

(function($, window) {
	// Focus the first interactable element in the container on which you call this
	$.fn.focusFirstElement = function() {
		let firstInput = $(this).find("input, button, select").filter(":first");

		if (
			firstInput.is("select") &&
			firstInput.siblings(".chosen-container").length
		) {
			return firstInput.trigger("chosen:activate");
		} else {
			return firstInput.focus();
		}
	};

	// Call a function if an image is already loaded, or when the image loads.
	$.fn.ifOrWhenLoaded = function(fn) {
		if (this.prop("complete")) {
			fn();
		} else {
			this.on("load.helpers", () => {
				this.off("load.helpers");
				return fn();
			});
		}
		return this;
	};

	$.fn.getPrefixedDuration = function(prop) {
		let prefixes = ["", "-webkit-", "-moz-", "-ms-", "-o-"];
		for (let prefix of prefixes) {
			if (this.css(prefix + prop)) {
				return Math.round(parseFloat(this.css(prefix + prop)) * 1000);
			}
		}
		return 0;
	};

	// Get the CSS transition speed
	$.fn.transitionSpeed = function() {
		return this.getPrefixedDuration("transition-duration");
	};

	// Get the CSS animation speed
	return ($.fn.animationSpeed = function() {
		return this.getPrefixedDuration("animation-duration");
	});
})(jQuery, window);

function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}



// WEBPACK FOOTER //
// ./src/legacy/helpers.js